import receptionIllustration from '@/assets/planner/reception.svg'
import { Screen } from '@/patterns/screen'
import { SectionTabs } from '@/patterns/section-tabs'
import { useToast } from '@/shell/toaster'
import { ReceptionMaterials } from './materials'
import { ReceptionGuests, ReceptionPlanCard, ReceptionVendorMeals } from './overview'
import { ReceptionBudgetNote, ReceptionPrompts, ReceptionTasks } from './preparations'

export function ReceptionScreen() {
  const { showToast } = useToast()
  const preview = (title: string) =>
    showToast({ title, description: 'Tenhle krok doplníme po schválení přehledu.' })

  return (
    <Screen
      eyebrow="Plánovač"
      title="Jídlo a pití"
      description="Vaše menu, nápoje a sladké přehledně na jednom místě."
      illustration={
        <img
          src={receptionIllustration}
          alt=""
          width={200}
          height={128}
          className="h-auto w-full"
        />
      }
      tabs={
        <SectionTabs
          label="Stránky jídla a pití"
          active="/reception"
          tabs={[
            { to: '/reception', label: 'Přehled' },
            { to: '/reception/food', label: 'Jídlo', disabled: true },
            { to: '/reception/drinks', label: 'Pití', disabled: true },
            { to: '/reception/sweets', label: 'Dort a sladké', disabled: true },
          ]}
        />
      }
    >
      <div className="grid items-start gap-6 xl:grid-cols-[minmax(0,1.35fr)_minmax(0,1fr)]">
        <ReceptionPlanCard onPreview={preview} />
        <div className="space-y-6">
          <ReceptionGuests />
          <ReceptionVendorMeals onPreview={preview} />
        </div>
      </div>
      <ReceptionPrompts />
      <ReceptionTasks />
      <ReceptionMaterials onPreview={preview} />
      <ReceptionBudgetNote />
    </Screen>
  )
}
